'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

require('../../styles/sections/theme-footer.scss');

exports.default = (0, _themeSections.register)('theme-footer', {
  onLoad: function onLoad() {
    // Product wechat code
    var weChatPopup = new Limelight('#PopupWeChat', {
      bodyClass: 'active-popup'
    });

    // Popup submenus
    var footerDrawers = this.container.querySelectorAll('[data-trigger="drawer-menu"]');
    window.footerMenus = [];

    footerDrawers.forEach(function (drawer, index) {
      footerMenus[index] = new Limelight('' + drawer.dataset.target, {
        beforeShowCallback: function beforeShowCallback(element, elements) {
          drawer.closest('.footer-nav-links').classList.add('invisible');
          element.element.querySelector('[data-scroll-state]').scrollTop = 0;
        },
        beforeHideCallback: function beforeHideCallback(element, elements) {
          drawer.closest('.footer-nav-links').classList.remove('invisible');
        }
      });
    });

    // Footer popup on colelctions page without navigation
    var popupOpenButtons = this.container.getElementsByClassName('footer-coll-without-nav__btn');
    if (popupOpenButtons.length) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = popupOpenButtons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var popupOpenButton = _step.value;

          popupOpenButton.addEventListener('click', function () {
            var id = this.dataset['target'];
            var popup = document.getElementById(id);

            popup.classList.add('active');
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var popupCloseButtons = this.container.getElementsByClassName('footer-coll-without-nav__popup-close');
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = popupCloseButtons[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var popupCloseButton = _step2.value;

          popupCloseButton.addEventListener('click', function () {
            var id = this.dataset['target'];
            var popup = document.getElementById(id);

            popup.classList.remove('active');
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }
});